import {ServerNotificationProps} from '../../ServerNotification';
import {INotificationProps} from '@src/@interfaces/components/Notifications/INotificationProps';
import app from '@src/helpers/app';
import getUri from '@src/helpers/getUri';
import InfoNotification from '@src/components/Notifications/InfoNotification';
import {toDate} from '@views/orders/fields/logs/messages';
import {getProductionDashboardUrlIfPossible} from './getProductionDashboardUrlIfPossible';
import {
    getManagerDashboardProductsListSearchParams
} from '@src/components/Notifications/server-notifications/Order/Product/getManagerDashboardProductsListSearchParams';
import {
    getSearchTermParams
} from '@src/components/Notifications/server-notifications/Order/Product/getSearchTermParams';
import makeUrl from '@src/components/Notifications/server-notifications/makeUrl';

export default class DeadlineChanged extends InfoNotification<
        ServerNotificationProps<'App\\Notifications\\Order\\Product\\DeadlineChanged'> &
        INotificationProps
> {
    protected getWrapperTagProps(): any {
        const payload = this.props.notification.data;
        const namesResolver = app('names-resolver').clientRoutes;

        const getSearchParams = (params: Record<string, string>) => {
            return getSearchTermParams('OrderProducts', String(payload.orderId), params);
        };

        let toUrl = getProductionDashboardUrlIfPossible(payload.orderProductId);
        if (!toUrl) {
            toUrl = getUri({
                route: namesResolver.getShowRouteName('Orders'),
                params: {
                    id: String(payload.orderId),
                },
            });
        }

        const searchParams = getSearchParams(
                getManagerDashboardProductsListSearchParams({
                    productId: String(payload.orderProductId ?? 0),
                })
        );

        return {
            ...super.getWrapperTagProps(),
            to: makeUrl({url: toUrl, searchParams, hash: '#OrdersShow.tabs.products'}),
        };
    }

    protected getDescriptionReplacements() {
        const data = this.props.notification.data;

        return {
            ...data,
            was: toDate(data.was),
            became: toDate(data.became),
        };
    }
}
